import { connect } from 'react-redux';
import { push } from 'react-router-redux/lib/actions';
import { PROMOTION_ROUTER_ROOT } from './../constants';
import PromotionEdit from './PromotionEdit';
import {PromotionCRUDActions} from '../../../actions/promotion';

// new way of actions. Has to have less memory in use;
let CRUDActions = new PromotionCRUDActions();

export default connect(
  ({promotion: {loadingItem, model}}) => ({
    title: 'Edit Promotion',
    loading: loadingItem,
    model,
    initialValues: Object.assign({}, model)
  }),
  dispatch => ({
    fetch: (id) => dispatch(CRUDActions.fetch(id)),
    save: (item, data) => dispatch(CRUDActions.save(item, data)),
    goIndex: () => dispatch(push(PROMOTION_ROUTER_ROOT))
  })
)(PromotionEdit)





// WEBPACK FOOTER //
// ./src/components/Promotions/PromotionEdit/index.js